import includes from 'lodash/includes';
import {matchRoutes} from 'react-router-config';

// Path-only route metadata, deliberately kept free of page component imports.
// routes.js imports this to build its full `routes` array (path + component),
// but modules that only need to match/validate a path (e.g. search-request.js)
// should import from here instead of routes.js to avoid pulling in every page
// component and creating a circular import back into routes.js.
export const routePaths = [
    {path: '/', exact: true},
    {path: '/search', isSearch: true},
    {path: '/event-packages-search', isSearch: true},
    {path: '/auth/callback', exact: true},
    {path: '/auth/pending', exact: true},
    {path: '/auth/restricted-login', exact: true},
    {path: '/login', exact: true},
    {path: '/auth/partner-login', exact: true},
    {path: '/auth/error'},
    {path: '/logout'},
];

export function matchPathToRoute(path) {
    const matches = matchRoutes(routePaths, path);

    if (!matches || matches.length === 0) {
        return null;
    }

    const [
        {
            match: {params},
            route,
        },
    ] = matches;

    return {...route, params};
}

export function isSearchPage(page, section) {
    return (
        page === 'search' ||
        includes(page, 'parking-near-me') ||
        includes(section, 'parking-near-me') ||
        (includes(page, '-parking') && !section) ||
        (!includes(page, '-parking') && includes(section, '-parking')) ||
        includes(page, '-monthly-parking')
    );
}

const possibleBasePages = routePaths
    .filter(route => !route.path.includes(':page'))
    .map(route => route.path.split('/')[1]);

export const excludedRoutes = ['favicon.ico'];

/**
 * Checks whether the provided path is a valid route on the server that requires loading of APIs and other page setup functionality.
 * This is necessary so that certain initial load paths (like the excluded routes above or error routes) don't overload the server with
 * unnecessary API calls.
 * @function isValidRoute
 * @param {string} path - The requested path.
 * @example
 * isValidRoute('/'); // true
 * isValidRoute('/chicago/ohare-airport-parking'); // true
 * isValidRoute('/logout'); // false
 * @returns {boolean} - Whether the path is a valid route.
 */
export function isValidRoute(path) {
    const [, page, section] = path.split('/');

    return (
        path === '/' || // homepage
        includes(possibleBasePages, page) || // a base route match (/airport-parking/*, /facility/*, etc)
        isSearchPage(page, section) || // a search page (excluding redirects like /[city] -> /[city]-parking)
        !includes(excludedRoutes, page) // this MUST be the last condition checked
    );
}
